import { ROUTE_CONTRACT_COST_ESTIMATES, ROUTE_CREATE_EDIT_POST_EXHIBIT, ROUTE_WELCOME } from "../routes/Routes";
import { useEffect } from "react";
import { useState } from "react";
import DataGridPostExhibits from "../PostExhibitPage/components/DataGridPostExhibits";
import { LoadingPanel } from "../components/LoadingPanel";
import { fetchPostExhibits } from "../PostExhibitPage/PostExhibitsService";
import IsNullOrEmpty from "../components/IsNullOrEmpty";
import { getPostExhibitStatusIdByName } from "../Enums/postExhibitStatuses";
import { Button } from "devextreme-react";
import { useNavigate } from "react-router-dom";

const ContractCostEstimates = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [contractEstimates, setContractEstimates] = useState();
    const navigate = useNavigate();
    const navigateToHomePage = () => navigate(ROUTE_WELCOME.withSlash);

    useEffect(() => {
        loadPostExhibits();
    }, []);

    const onBackClick = () => {
        navigateToHomePage();
    };

    const loadPostExhibits = async () => {
        setLoading(true);
        try {
            const draftStatusId = getPostExhibitStatusIdByName('Draft');
            const data = await fetchPostExhibits();
            setContractEstimates(data.filter(p =>
                p.PostExhibitStatus?.PostExhibitStatusId === draftStatusId &&
                !IsNullOrEmpty(p.ClonedPostExhibitId)
            ));
        } catch (error) {
            setError(error.message || "Error loading Cost Estimates");
        }
        setLoading(false);
    }

    return (
        <div>
            <h1>{ROUTE_CONTRACT_COST_ESTIMATES.title}</h1>
            {error && <p>Something went wrong.</p>}
            {loading && !contractEstimates && <LoadingPanel location={{ of: '#costEstimate-list' }} message="Loading Estimates List..." />}
            {contractEstimates &&
                <div id="costEstimate-list">
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: 8
                    }}>
                        <div style={{ display: 'flex', gap: 8 }}>
                            <Button
                                icon='plus'
                                stylingMode="contained"
                                text="Add Post Exhibit"
                                onClick={() => navigate(ROUTE_CREATE_EDIT_POST_EXHIBIT.withSlash)}
                                id="add_new_postexhibit_button_030"
                            />
                            <Button
                                text='Home'
                                icon='home'
                                stylingMode='outlined'
                                type='normal'
                                onClick={onBackClick}
                            />
                        </div>
                    </div>

                    <DataGridPostExhibits
                        dataSource={contractEstimates}
                        isCostEstimate={true}
                    />
                </div>
            }
        </div>
    )
}
export default ContractCostEstimates;